import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { verifyPasswordResetOTP, resendPasswordOTP } from '../api/forgot_password';
import OTPTimer from '../components/Timer';
import PageBottom from '../components/page-bottom/PageBottom';
import { getInfo, saveInfo, saveInfoAndPush } from './LoginSingupInfoManager';
import OTPInput from './OTPInputComponent';
import HeaderLogo from './logo/HeaderLogo';
import { emailRegex } from '../utility/constant';

const OtpVerify = ({ type }) => {
  const [otp, setOTP] = useState('');
  const [submitBtnState, setBtnState] = useState(false);
  const [apiError, setApiError] = useState('');
  const [showTimer, setShowTimer] = useState(true);
  const navigate = useNavigate();

  // const getUserInfo = () => {
  //   const data = getInfo();
  //   const jsonData = data.data;
  //   let userInput = jsonData.userId;
  //   let visibleInput = userInput.slice(0, 4);
  //   let nonVisibleInput = userInput.slice(4, userInput.length);
  //   let replace = nonVisibleInput.replace(/./gi, 'x');
  //   let userData = visibleInput + replace;
  //   return userData;
  // };
  const getUserMobile = () => {
    let edata = getInfo();
    let userId = edata.data.userId;
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    if (emailRegex.test(userId)) {
      // Mask email: e.g., j***@example.com
      let [local, domain] = userId.split('@');
      let maskedLocal = local[0] + '***';
      return `${maskedLocal}@${domain}`;
    } else {
      // Assume it's a phone number
      let visbleInput = '+91';
      let nonVisibleInput = 'XXXXXXXX';
      let lastTwoDigits = userId.slice(-2);
      return visbleInput + nonVisibleInput + lastTwoDigits;
    }
  };  

  const otpChange = (event) => {
    let otp = event || '',
      submitBtnState = false;
    const pattern = /^([0-9]{0,6})?$/;

    if (!otp) {
      submitBtnState = false;
    } else if (!pattern.test(otp)) {
      submitBtnState = true;
    } else {
      submitBtnState = false;
    }
    setBtnState(submitBtnState);
    setOTP(otp);
  };

  const redirect = (data) => {
    const loginData = data;
    saveInfoAndPush(loginData, '/resetpassword', false, navigate);
  };

  const verify = () => {
    const edata = getInfo();
    const jsonData = edata.data;
    const data = {
      otp_id: jsonData.otp_id,
      otp: otp
    };
    verifyPasswordResetOTP(data)
      .then((res) => {
        if (res.status === 200) {
          redirect(res.data);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const errorMessage = error.response.data.non_field_errors?.[0];
          setApiError(errorMessage || 'Please enter a valid OTP.');
        } else {
          setApiError('Please enter a valid OTP.');
        }
        setOTP('');
      });
  };

  const resendOtp = () => {
    resend();
  };

  // const resendOtpViaCall = () => {
  //   resend(true);
  // };

  const resend = () => {
    const userData = getInfo();
    const jsonData = userData.data;
    const data = {
      otp_id: jsonData.otp_id,
      [emailRegex.test(jsonData.userId) ? 'email' : 'mobile']: jsonData.userId
    };
    resendPasswordOTP(data)
      .then((res) => {
        if (res.status === 200) {
          const otpData = res.data;
          otpData['userId'] = jsonData.userId;
          saveInfo(otpData, '', false);
          setShowTimer(true);
        }
      })
      .catch((error) => {
        setApiError(error.response?.data?.non_field_errors?.[0] || 'Failed to resend OTP');
      });
  };

  return (
    <div className='row justify-content-center align-items-center h-100'>
      <div className='col-sm-3 px-0'>
        <BrowserView>
          <div className=' p-5 colored-box mb-6'>
            <HeaderLogo />
            <div className='h4 text-center heading-custom'>
              OTP Verification
            </div>
            <p className='text-center mt-3'>
              {'OTP has been sent to linked email/mobile-number: ' + getUserMobile()}
            </p>
            <div className='row mt-5 d-flex justify-content-center align-items-center'>
              <OTPInput
                autoFocus={true}
                isNumberInput
                length={6}
                className='mt-5 d-flex  '
                inputClassName='updated-input  form-control otp-input'
                onChangeOTP={otpChange}
              />
            </div>
            <label className={`text-center w-100 ${apiError ? 'is-invalid' : ''}`}>
                <div className="mt-4 font-weight-light text-danger ">
                 {apiError}
                      </div>
                  </label>
            <div className='mt-5 d-flex justify-content-between align-items-center'>
              <div>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Didnt recieved the OTP? </span>
                  <button
                    type='button'
                    className={
                      showTimer ? 'btn link-disabled' : 'btn link-enabled'
                    }
                    style={showTimer ? { pointerEvents: 'none' } : null}
                    onClick={resendOtp}
                  >
                    Resend OTP
                  </button>
                  {showTimer ? (
                    <OTPTimer
                      className='enabled'
                      initialSeconds='30'
                      onComplete={setShowTimer}
                    ></OTPTimer>
                  ) : (
                    ''
                  )}
                </div>
                {/* <div>
                  {type === 'mobile' ? (
                    <button
                      type='button'
                      className={
                        showTimer ? 'btn link-disabled' : 'btn link-enabled'
                      }
                      style={showTimer ? { pointerEvents: 'none' } : null}
                      onClick={resendOtpViaCall}
                    >
                      {' '}
                      Send OTP Via Call
                    </button>
                  ) : null}
                </div> */}
              </div>
            </div>
            <div className='row justify-content-center align-items-center mt-4'>
              <button
                type='button'
                className='btn btn-primary'
                onClick={verify}
                disabled={submitBtnState}
              >
                Continue
              </button>
            </div>
          </div>
        </BrowserView>
        <MobileView>
          <div className=' p-5 bg-light-grey pb-6'>
            <div className='h4 text-center heading-custom'>
              OTP Verification
            </div>
            <p className='text-center mt-3'>
              {'OTP has been sent to linked email/mobile-number: ' + getUserMobile()}
            </p>
            <div className='row mt-5 d-flex justify-content-center align-items-center'>
              <OTPInput
                autoFocus={true}
                isNumberInput
                length={6}
                className='mt-5 d-flex  '
                inputClassName='updated-input bg-light-grey form-control otp-input'
                onChangeOTP={otpChange}
              />
            </div>
            <label className={`text-center w-100 ${apiError ? 'is-invalid' : ''}`}>
                <div className="mt-4 font-weight-light text-danger ">
                 {apiError}
                      </div>
                  </label>
            <div className='row justify-content-center align-items-center mt-4'>
              <button
                type='button'
                className='btn btn-primary w-100'
                onClick={verify}
                disabled={submitBtnState}
              >
                Continue
              </button>
            </div>
            {showTimer ? (
              <OTPTimer
                className='enabled'
                initialSeconds='30'
                onComplete={setShowTimer}
              ></OTPTimer>
            ) : (
              ''
            )}
            <div className='mt-5 d-flex justify-content-between align-items-center'>
              <div>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Didnt recieved the OTP? </span>
                  <button
                    type='button'
                    className={
                      showTimer ? 'btn link-disabled' : 'btn link-enabled'
                    }
                    style={showTimer ? { pointerEvents: 'none' } : null}
                    onClick={resendOtp}
                  >
                    Resend OTP
                  </button>
                </div>
                {/* <div>
                  {type === 'mobile' ? (
                    <button
                      type='button'
                      className={
                        showTimer ? 'btn link-disabled' : 'btn link-enabled'
                      }
                      style={showTimer ? { pointerEvents: 'none' } : null}
                      onClick={resendOtpViaCall}
                    >
                      {' '}
                      Send OTP Via Call
                    </button>
                  ) : null}
                </div> */}
              </div>
            </div>
          </div>
        </MobileView>
        <PageBottom />
      </div>
    </div>
  );
};
OtpVerify.propTypes = {
  type: PropTypes.string,
};
export default OtpVerify;
